import { DebugService } from './debug.service.js';

export class _HostAppEventsService {
  constructor() {
    this.debug = new DebugService('HostAppEventsService');
  }

  sendNextStepEvent(step) {
    document.dispatchEvent(
      new CustomEvent('next-step', {
        bubbles: true,
        composed: true,
        detail: {
          step,
          sentFrom: 'offers',
        },
      }),
    );
  }

  sendNextMfeEvent() {
    document.dispatchEvent(
      new CustomEvent('next-mfe', {
        bubbles: true,
        composed: true,
        detail: {
          sentFrom: 'offers',
        },
      }),
    );
  }
}

export const HostAppEventsService = new _HostAppEventsService();
